import { useGetIpLocation } from '@/features/auth/services/ip-location';
import { useCountries } from '@/features/auth/hooks/use-countries';
import { useMemo } from 'react';
import { isInApp } from '@/libs/comeAppSDK';

/**
 * 全局 IP 位置 Hook
 * 使用缓存避免重复请求
 */
export const useIpCountry = () => {
  const { data: locationData, isLoading: loading, error } = useGetIpLocation.useQueryHook({
    params: {},
  });
  const { findCountry } = useCountries();

  // 根据 IP 位置获取国家信息 - 使用 useMemo 优化
  const country = useMemo(() => {
    return locationData?.country
      ? findCountry(locationData.country)
      : undefined;
  }, [locationData?.country, findCountry]);

  // TODO: 后续需要根据ip获取的国家来判断
  const selectedCountry = useMemo(() => {
    return isInApp() ? findCountry('IN') : country;
  }, [country]);

  return {
    locationData,
    country,
    selectedCountry,
    loading,
    error,
  };
};
